import GroupManagementUtil from "./group_management_util"
import messageResource from "../messageResource"
import RpcControlManager from "../rpc_control_manager"
import {UserGroupValidatorStrategy} from "../util/GroupValidatorStrategy"
import {escapeHtmlSymbols} from "../atUtils"
import {addClass, removeClass} from "../atBrowserUtils"

/**
 * Controls all operations with groups in group management lightbox
 */
export default function GroupController() {}

/**
 * @param config.topGroupNameLabel group name label over user container
 * @param config.deletedNowGroupClassName class name for group row in deleted in process state(ajax request processed now)
 * @param config.editedNowGroupClassName class name for group row in edited in process state(ajax request processed now)
 * @param config.movedInNowGroupClassName class name for group row in moved users into in process state(ajax request processed now)
 * @param config.editedClassName class name for group row in edited state
 * @param config.confirmDeleteClassName class name for group row in confirm delete state
 * @param config.errorTextClassName class name for groups duplicated on server
 * @param config.groupDivIdPrefix dom id prefix for group row
 * @param config.groupDeleteLinkIdPrefix dom id prefix for group delete button
 * @param config.undoDeleteIdPrefix dom id prefix for group undo delete button
 * @param config.acceptDeleteIdPrefix dom id prefix for group accept delete button
 * @param config.undoEditIdPrefix dom id prefix for group undo edit button
 * @param config.acceptEditIdPrefix dom id prefix for group accept edit button
 * @param config.editInputIdPrefix dom id prefix for group edit input field
 * @param config.nameCellIdPrefix dom id prefix for cell with group name
 * @param config.inputCellIdPrefix dom id prefix for cell with edit group input field
 * @param config.editGroupCellIdPrefix dom id prefix for cell for edited group table
 * @param config.waitingAnimationCellIdPrefix  dom id prefix for cell with waiting ajax animation
 * @param config.spinnerContainerIdPrefix  dom id prefix for spinner container
 */
GroupController.prototype.init = function(config) {
    this.topGroupNameLabel = config.topGroupNameLabel;
    this.deletedNowGroupClassName = config.deletedNowGroupClassName;
    this.editedNowGroupClassName = config.editedNowGroupClassName;
    this.movedInNowGroupClassName = config.movedInNowGroupClassName;
    this.editedClassName = config.editedClassName;
    this.confirmDeleteClassName = config.confirmDeleteClassName;
    this.errorTextClassName = config.errorTextClassName;
    this.groupDivIdPrefix = config.groupDivIdPrefix;
    this.groupDeleteLinkIdPrefix = config.groupDeleteLinkIdPrefix;
    this.undoDeleteIdPrefix = config.undoDeleteIdPrefix;
    this.acceptDeleteIdPrefix = config.acceptDeleteIdPrefix;
    this.undoEditIdPrefix = config.undoEditIdPrefix;
    this.acceptEditIdPrefix = config.acceptEditIdPrefix;
    this.editInputIdPrefix = config.editInputIdPrefix;
    this.nameCellIdPrefix = config.nameCellIdPrefix;
    this.inputCellIdPrefix = config.inputCellIdPrefix;
    this.editGroupCellIdPrefix = config.editGroupCellIdPrefix;
    this.waitingAnimationCellIdPrefix = config.waitingAnimationCellIdPrefix;
    this.spinnerContainerIdPrefix = config.spinnerContainerIdPrefix;
    this.spinnerController = config.spinnerController;
    this.selectedGroup = null;
    this.editedGroup = null;
    this.confirmDeleteGroup = null;
    this.markedAsDuplicateGroups = new Array();

    this.groupNamingKey = config.groupNamingKey;
    this.GroupNamingKey = config.GroupNamingKey;

    return this;
};

/**
 * Init controller
 * @param data array of GroupWithUsers instances
 * @param controller user group management controller
 */
GroupController.prototype.initGroups = function(data, controller) {
    this.cleanup();
    this.groups = {};
    for (var i = 0; i < data.length; i++) {
        this.groups[data[i].id] = this.createGroupRow(data[i], controller);
        controller.getDDController().makeDDWrapperForGroup(document.getElementById(formatId(this.groupDivIdPrefix, data[i].id)));
    }
    if (this.selectedGroup != null) {
        if (!this.groups[this.selectedGroup.id]) {
            this.selectedGroup = null;
        }
    }
};

GroupController.prototype.createGroupRow = function(group, controller)
{
    return new GroupRow().init(
            document.getElementById(formatId(this.groupDivIdPrefix, group.id)),
            document.getElementById(formatId(this.groupDeleteLinkIdPrefix, group.id)),
            document.getElementById(formatId(this.undoDeleteIdPrefix, group.id)),
            document.getElementById(formatId(this.acceptDeleteIdPrefix, group.id)),
            document.getElementById(formatId(this.undoEditIdPrefix, group.id)),
            document.getElementById(formatId(this.acceptEditIdPrefix, group.id)),
            document.getElementById(formatId(this.editInputIdPrefix, group.id)),
            document.getElementById(formatId(this.nameCellIdPrefix, group.id)),
            document.getElementById(formatId(this.inputCellIdPrefix, group.id)),
            document.getElementById(formatId(this.editGroupCellIdPrefix, group.id)),
            document.getElementById(formatId(this.waitingAnimationCellIdPrefix, group.id)),
            group, new UserGroupValidatorStrategy(), controller
    );
};

/**
 * Handles user group selection
 * @param controller user group management controller
 * @param groupId id of user group intended for selection
 */
GroupController.prototype.groupSelected = function(controller, groupId) {
    var newSelectedGroup = this.groups[groupId];
    if (this.selectedGroup) {
        controller.getHighlightController().unhighlightSelectedGroup(this.selectedGroup);
    }
    controller.getHighlightController().highlightSelectedGroup(newSelectedGroup);
    this.changeTopGroupNameLabel(newSelectedGroup);
    this.selectedGroup = newSelectedGroup;
};

GroupController.prototype.highlightGroup = function(controller, groupId)
{
    var groupToHighlight = this.groups[groupId];
    controller.getHighlightController().highlightHoveredGroup(groupToHighlight);
    setTimeout( function() {
        controller.getHighlightController().unhighlightHoveredGroup(groupToHighlight);
    }, 1500);
};

/**
 * Change name of selected user group over user container
 * @param group
 */
GroupController.prototype.changeTopGroupNameLabel = function(group) {
    this.topGroupNameLabel.innerHTML = "<span class='groupName'>" + escapeHtmlSymbols(group.name) + '</span><span>&nbsp;(' + group.countOfUserWithEnabledAccess() + ')</span>';
};

/**
 * Get object of all GroupRow instances by id
 */
GroupController.prototype.getGroups = function() {
    return this.groups;
};

/**
 * Get GroupRow instance by id
 * @param groupId id of user group
 */
GroupController.prototype.getGroup = function(groupId) {
    return this.groups[groupId];
};

/**
 * Defines is group suitable for drop in or not
 * @param groupId
 */
GroupController.prototype.isGroupSuitableForDrop = function(groupId) {
    return (groupId != this.selectedGroup.id) && (this.editedGroup == null || groupId != this.editedGroup.id);
};

/**
 * Get all GroupRow instances suitable for drop in
 */
GroupController.prototype.getGroupsSuitableForDrop = function() {
    var suitableGroups = new Array();
    for (var i in this.groups) {
        //noinspection JSUnfilteredForInLoop
        if (this.isGroupSuitableForDrop(this.groups[i].id)) {
            //noinspection JSUnfilteredForInLoop
            suitableGroups.push(this.groups[i]);
        }
    }
    return suitableGroups;
};

/**
 * Mark user group row as deleted in process state(ajax request processed now)
 * @param groupId id of user group
 */
GroupController.prototype.markGroupAsDeletedNow = function(groupId) {
    var group = this.groups[groupId];
    group.markAsAjaxProcessedNow(this.deletedNowGroupClassName);

    this.spinnerController.spin(formatId(this.spinnerContainerIdPrefix, group.id));
};

/**
 * Mark user group row as edited in process state(ajax request processed now)
 * @param groupId id of user group
 */
GroupController.prototype.markGroupAsEditedNow = function(groupId) {
    var group = this.groups[groupId];
    group.markAsAjaxProcessedNow(this.editedNowGroupClassName);

    this.spinnerController.spin(formatId(this.spinnerContainerIdPrefix, group.id));
};

/**
 * Mark user group row as moved users into in process state(ajax request processed now)
 * @param groupId id of user group
 */
GroupController.prototype.markGroupAsMovedInNow = function(groupId) {
    var group = this.groups[groupId];
    group.markAsAjaxProcessedNow(this.movedInNowGroupClassName);

    this.spinnerController.spin(formatId(this.spinnerContainerIdPrefix, group.id));
};

/**
 * Change user group row state into editing
 * @param group GroupRow instance
 */
GroupController.prototype.startGroupEditing = function(group) {
    addClass(group.div, this.editedClassName);
    group.disableRowForEditing();
    this.editedGroup = group;
    setFocusToEndOfInput(group.input);
};

GroupController.prototype.confirmGroupDelete = function(group) {
    addClass(group.div, this.confirmDeleteClassName);
    group.disableRow();
    group.focusAcceptDeleteButton();
    this.confirmDeleteGroup = group;
};

/**
 * Change user group row state from editing to normal.
 * Returns true if there is edited user group now and false otherwise
 */
GroupController.prototype.endGroupEditing = function() {
    if (this.editedGroup) {
        removeClass(this.editedGroup.div, this.editedClassName);
        this.editedGroup.enableRow();
        this.editedGroup.revertInputText();
        GroupManagementUtil.markCellAsValid(this.editedGroup.inputCell);
        this.editedGroup.input.blur();
        this.editedGroup = null;
        return true;
    }
    return false;
};

GroupController.prototype.endConfirmGroupDelete = function() {
    if (this.confirmDeleteGroup) {
        removeClass(this.confirmDeleteGroup.div, this.confirmDeleteClassName);
        this.confirmDeleteGroup.enableRow();
        this.confirmDeleteGroup = null;
        return true;
    }
    return false;
};

/**
 * Start saving of new user group name. Check emptiness and uniqueness. Repaint row if group name is empty or duplicate.
 * @param controller user group management controller
 * @param group GroupRow instance
 */
GroupController.prototype.startNewGroupNameSaving = function(controller, group) {
    var name = group.input.value;
    var title = null;
    var errorMessage = null;
    if (name.trim() == '') {
        title =  messageResource.getMessage("group_management.error.empty_name.user_group", [messageResource.getEscapedMessage(  this.groupNamingKey)]);
        errorMessage =  messageResource.getMessage("group_management.client_side.empty_name.user_group", [messageResource.getEscapedMessage(  this.groupNamingKey)]);
    } else if (this.isDuplicateName(name, group.id)) {
        title =  messageResource.getMessage("group_management.error.duplicate_name.user_group", [messageResource.getMessage(  this.GroupNamingKey)]);
        errorMessage =  messageResource.getMessage("group_management.client_side.group_exists.user_group", [messageResource.getEscapedMessage(  this.groupNamingKey)]);
    }
    if (title) {
        GroupManagementUtil.markCellAsInvalid(group.inputCell, title);
        setTimeout(function() {controller.showErrorMessage(errorMessage)}, 100);
    } else {
        removeClass(group.div, this.editedClassName);
        var manager = new GroupEditRPCManager(controller.getServiceName(), controller, this.getGroupData(group, name), this.groupNamingKey);
        RpcControlManager.saveRpcControlBoundData(manager, false);
    }
};

/**
 * Check duplicate name of user group on client side
 * @param name new name intended for check
 * @param unverifiedId id of user group doesn't take place in checking for duplicate(optional)
 */
GroupController.prototype.isDuplicateName = function(name, unverifiedId) {
    var trimmedLowercaseName = name.trim().toLowerCase();
    for (var i in this.groups) {
        //noinspection JSUnfilteredForInLoop
        if ((this.groups[i].name.trim().toLowerCase() == trimmedLowercaseName) && (!unverifiedId || this.groups[i].id != unverifiedId)) {
            return true;
        }
    }
    return false;
};

/**
 * Paint duplicated on server groups as red
 * @param editedGroupId group, edited before error
 * @param duplicatedName name of user group, caused an error
 */
GroupController.prototype.paintDuplicateGroupsAsRed = function(editedGroupId, duplicatedName) {
    var firstGroup = this.groups[editedGroupId];
    if (firstGroup) {
        addClass(firstGroup.nameCell, this.errorTextClassName);
        this.markedAsDuplicateGroups.push(firstGroup);
    }
    var trimmedLowerCaseGroupName = duplicatedName.trim().toLowerCase();
    for (var i in this.groups) {
        //noinspection JSUnfilteredForInLoop
        if (trimmedLowerCaseGroupName == this.groups[i].name.trim().toLowerCase()) {
            //noinspection JSUnfilteredForInLoop
            addClass(this.groups[i].nameCell, this.errorTextClassName);
            //noinspection JSUnfilteredForInLoop
            this.markedAsDuplicateGroups.push(this.groups[i]);
            break;
        }
    }
    //Fix for Chrome bug. It doesn't change cursor from waiting state.
    document.body.style.cursor = "default";
};

/**
 * Paint user groups marked as duplicate as normal
 */
GroupController.prototype.paintDuplicateGroupsAsValid = function() {
    for (var i = 0; i < this.markedAsDuplicateGroups.length; i++) {
        removeClass(this.markedAsDuplicateGroups[i].nameCell, this.errorTextClassName);
    }
    this.markedAsDuplicateGroups = new Array();
};

/**
 * Clean edited user group. Don't clean selected user group because it is saved.
 */
GroupController.prototype.cleanup = function() {
    this.editedGroup = null;
};

/**
 * Get selected now GroupRow instance
 */
GroupController.prototype.getSelectedGroup = function() {
    return this.selectedGroup;
};

/**
 * Get edited now GroupRow instance. Returns null if no user group is edited now.
 */
GroupController.prototype.getEditedGroup = function() {
    return this.editedGroup;
};

GroupController.prototype.getGroupData = function(group, name)
{
    return {
        id: group.id,
        name: name
    }
};


// WEBPACK FOOTER //
// ./web/js/groupManagement/group_controller.js